<template>
  <div>
    <v-card width="400px" class="mt-5 mx-auto">
      <v-card-title>
        <h1>{{$t('login')}}</h1>
      </v-card-title>
      <div v-if="setPartnerPass">Wollen Sie Zugriff auf ihren Account gewähren? Dann loggen Sie sich bitte hier ein.</div>
      <v-card-text>
        <v-form value>
          <v-text-field
            :label="$t('username')"
            prepend-icon="mdi-account-circle"
            v-model="email"
          />
          <v-text-field
            :label="$t('password')"
            prepend-icon="mdi-lock"
            :type="showLogin ? 'text' : 'password'"
            :append-icon="showLogin ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showLogin=!showLogin"
            v-model="password"
            @keydown.enter.prevent="login"
          />
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn
          color="info"
          class="mx-auto px-4"
          @click="login"
        >
          {{$t('login')}}
        </v-btn>
        <v-btn
            color="primary"
            class="mx-auto px-4"
            @click="forgotPassword"
        >
          {{$t('forgot password')}}
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-snackbar
      v-model="loginFail"
      color="error"
      multi-line="multi-line"
    >
      <v-layout align-center pr-4>
        <v-icon class="pr-3" dark large>mdi-alert-circle</v-icon>
        <v-layout column>
          <div>{{loginFailMessage}}</div>
        </v-layout>
      </v-layout>
    </v-snackbar>
    <v-snackbar
        v-model="emailVerified"
        color="success"
        multi-line="multi-line"
    >
      <v-layout align-center pr-4>
        <v-icon class="pr-3" dark large>mdi-alert-circle</v-icon>
        <v-layout column>
          <div>{{$t('emailSuccessMessage')}}</div>
        </v-layout>
      </v-layout>
    </v-snackbar>
    <v-snackbar
        v-model="emailError"
        color="error"
        multi-line="multi-line"
    >
      <v-layout align-center pr-4>
        <v-icon class="pr-3" dark large>mdi-alert-circle</v-icon>
        <v-layout column>
          <div>{{$t('emailErrorMessage')}}</div>
        </v-layout>
      </v-layout>
    </v-snackbar>
  </div>
</template>
<script>
import APIService from "@/services/APIService";
import {mapMutations} from "vuex";
import { refreshMesskursPermissions } from "@/services/messkursPermissions";

export default {
  name: 'LoginView',
  data () {
    return {
      email: '',
      password: '',
      showLogin: false,
      loginFail: false,
      loginFailMessage: '',
    }
  },
  methods: {
    ...mapMutations(['updateUser', 'setShowHeader']),
    login () {
      APIService.login(this.email, this.password).then(async (data) => {
        if (data && data.user && data.tokens) {
          // Speichere die Login-Daten (User + Tokens) im Store
          data.user.isSSO = false;
          this.updateUser(data);
          
          // Header einblenden, da lokaler Login erfolgreich
          this.setShowHeader(true);
          await refreshMesskursPermissions();
          
          // Weiterleitung zur Hauptansicht
          this.$router.push({ name: 'Home' });
        } else {
          this.handleLoginError();
        }
      }).catch(error => {
        console.error("Login failed:", error);
        this.handleLoginError();
      });
    },
    handleLoginError() {
      this.loginFailMessage = this.$t("login_fail_message") || "Login fehlgeschlagen. Bitte überprüfen Sie Ihre Daten.";
      this.loginFail = true;
      this.password = '';
    },
    forgotPassword() {
      // Vorerst deaktiviert oder Link zur C-Learning Seite
      window.open('https://c-learning.de/passwort-vergessen', '_blank');
    }
  }
}
</script>

<style scoped>

</style>
